module.exports = __webpack_public_path__ + "img/client8.2946bd57.svg";